import en from './en'
import zhCN from './zh-CN'
import zhTW from './zh-TW'
import ja from './ja'

export default {
  en: en,
  'zh-CN': zhCN,
  'zh-TW': zhTW,
  'ja': ja,
}